import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "tat"
})
export class TatPipe implements PipeTransform {
  transform(tatObject: any): string {
    if (!tatObject) return "NA";

    const transitTime = tatObject["transitTime"];

    if (!transitTime) return "NA";

    if (transitTime > 1) return `${transitTime} Days`;
    if (transitTime == 1) return `${transitTime} Day`;
  }
}
